export const pxlColors = new Uint32Array([
    0xFF545454, 0xFF741E00, 0xFF901008, 0xFF880030, 0xFF640044, 0xFF30005C, 0xFF000454, 0xFF00183C,
    0xFF002A20, 0xFF003A08, 0xFF004000, 0xFF003C00, 0xFF3C3200, 0xFF000000, 0xFF000000, 0xFF000000,
    0xFF989698, 0xFFC44C08, 0xFFEC3230, 0xFFE41E5C, 0xFFB01488, 0xFF6414A0, 0xFF202298, 0xFF003C78,
    0xFF005A54, 0xFF007228, 0xFF007C08, 0xFF287600, 0xFF786600, 0xFF000000, 0xFF000000, 0xFF000000,
    0xFFECEEEC, 0xFFEC9A4C, 0xFFEC7C78, 0xFFEC62B0, 0xFFEC54E4, 0xFFB458EC, 0xFF646AEC, 0xFF2088D4,
    0xFF00AAA0, 0xFF00C474, 0xFF20D04C, 0xFF6CCC38, 0xFFCCB438, 0xFF3C3C3C, 0xFF000000, 0xFF000000,
    0xFFECEEEC, 0xFFECCCA8, 0xFFECBCBC, 0xFFECB2D4, 0xFFECAEEC, 0xFFD4AEEC, 0xFFB0B4EC, 0xFF90C4E4,
    0xFF78D2CC, 0xFF78DEB4, 0xFF90E2A8, 0xFFB4E298, 0xFFE4D6A0, 0xFFA0A2A0, 0xFF000000, 0xFF000000
]);
export const cssColors = [
    '#545454', '#001E74', '#081090', '#300088', '#440064', '#5C0030', '#540400', '#3C1800',
    '#202A00', '#083A00', '#004000', '#003C00', '#00323C', '#000000', '#000000', '#000000',
    '#989698', '#084CC4', '#3032EC', '#5C1EE4', '#8814B0', '#A01464', '#982220', '#783C00',
    '#545A00', '#287200', '#087C00', '#007628', '#006678', '#000000', '#000000', '#000000',
    '#ECEEEC', '#4C9AEC', '#787CEC', '#B062EC', '#E454EC', '#EC58B4', '#EC6A64', '#D48820',
    '#A0AA00', '#74C400', '#4CD020', '#38CC6C', '#38B4CC', '#3C3C3C', '#000000', '#000000',
    '#ECEEEC', '#A8CCEC', '#BCBCEC', '#D4B2EC', '#ECAEEC', '#ECAED4', '#ECB4B0', '#E4C490',
    '#CCD278', '#B4DE78', '#A8E290', '#98E2B4', '#A0D6E4', '#A0A2A0', '#000000', '#000000'
];
